import { Injectable } from '@angular/core';
import {
   Router,
   CanActivate,
   CanActivateChild,
   CanLoad,
   ActivatedRouteSnapshot,
   Route,
   UrlTree,
} from '@angular/router';

import { forkJoin, Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { ErrorMessageService } from '@library/core/services';

import { UseraccessService } from './useraccess.service';

@Injectable()
export class UserAccessGuard implements CanActivate, CanActivateChild, CanLoad {

   constructor(
      private access: UseraccessService,
      private router: Router,
      private error: ErrorMessageService,
   ) { }

   canActivate( route: ActivatedRouteSnapshot, ): Observable<boolean | UrlTree> | boolean | UrlTree {
      const access = route.data.access;
      const nextRoute = route.data.nextRoute;

      const getAccess = (Array.isArray( access ) ?
      forkJoin(access.map((a) => this.hasAccess( a ).pipe( first() )))
      :
      forkJoin([this.hasAccess( access ).pipe( first() )]));

      return getAccess.pipe(
            map( access => {
               if ( access.reduce((p, c) => p || c, false) ) { return true; }

               this.error.add({
                  type: 'alert',
                  code: 'ACCESS',
                  message: `You do not have access to view ${route.url}`,
               });

               return this.router.createUrlTree([ nextRoute || '/' ]);
            }),
         );
   }

   canActivateChild( route: ActivatedRouteSnapshot, ): Observable<boolean | UrlTree> | boolean | UrlTree {
      return this.canActivate( route );
   }

   canLoad( route: Route ): Observable<boolean> | boolean {
      return this.hasAccess( route.data.access );
   }

   hasAccess( access: string ): Observable<boolean> {
      if ( !access ) { return of( true ); }

      return this.access.hasAccess( access );
   }
}
